module.exports = __webpack_public_path__ + "static/media/ph_clipboard_data_1.c3166c51.svg";